/**
 * Advisory Request API Service
 *
 * Service layer for advisory request endpoints
 * Base URL: /market/v1/lead-request
 */

import { apiMain } from './apiService';
import {
  CreateLeadRequestDTO,
  UpdateLeadRequestDTO,
  CreateInvitationLinkDTO,
  UpdateInvitationLinkDTO,
  LeadRequestFilters,
  LeadRequestWithUserData,
  LeadRequestsWithUserDataResponse,
  InvitationLink,
} from '../types/leadRequestsTypes';

export const advisoryService = {
  /**
   * Create a new lead request
   * POST /market/v1/lead-request
   * Returns enriched data with user information
   */
  createLeadRequest: async (data: CreateLeadRequestDTO): Promise<LeadRequestWithUserData> => {
    const response = await apiMain.post('/market/v1/lead-request', data);
    return response.data;
  },

  /**
   * Get lead requests with filters and pagination
   * GET /market/v1/lead-request
   * Returns enriched data with user information (requester_user_data, lead_user_data)
   */
  getLeadRequests: async (
    params?: LeadRequestFilters
  ): Promise<LeadRequestsWithUserDataResponse> => {
    const response = await apiMain.get('/market/v1/lead-request', { params });
    return response.data;
  },

  /**
   * Get a specific lead request by ID
   * GET /market/v1/lead-request/{id_request}
   * Returns enriched data with user information
   */
  getLeadRequest: async (id: string): Promise<LeadRequestWithUserData> => {
    const response = await apiMain.get(`/market/v1/lead-request/${id}`);
    return response.data;
  },

  /**
   * Update a lead request
   * PATCH /market/v1/lead-request/{id_request}
   * Returns enriched data with user information
   */
  updateLeadRequest: async (
    id: string,
    data: UpdateLeadRequestDTO
  ): Promise<LeadRequestWithUserData> => {
    const response = await apiMain.patch(`/market/v1/lead-request/${id}`, data);
    return response.data;
  },

  /**
   * Create an invitation link
   * POST /market/v1/lead-request/invitation-link
   */
  createInvitationLink: async (data: CreateInvitationLinkDTO): Promise<InvitationLink> => {
    const response = await apiMain.post('/market/v1/lead-request/invitation-link', data);
    return response.data;
  },

  /**
   * Get an invitation link by ID
   * GET /market/v1/lead-request/invitation-link/{id_link}
   */
  getInvitationLink: async (id: string): Promise<InvitationLink> => {
    const response = await apiMain.get(`/market/v1/lead-request/invitation-link/${id}`);
    return response.data;
  },

  /**
   * Update an invitation link
   * PATCH /market/v1/lead-request/invitation-link/{id_link}
   */
  updateInvitationLink: async (
    id: string,
    data: UpdateInvitationLinkDTO
  ): Promise<InvitationLink> => {
    const response = await apiMain.patch(`/market/v1/lead-request/invitation-link/${id}`, data);
    return response.data;
  },
};
